<script>
import toHTML from 'linkifyjs/html';
import { editGroupOpinion } from '../api/group-opinions';
import { editOpinion } from '../api/opinions';

export default {
  name: 'CpOpinionsItem',
  directives: {
    margin: require('../directives/margins').margin,
    marginBottom: require('../directives/margins').marginBottom,
    marginTop: require('../directives/margins').marginTop,
    marginRight: require('../directives/margins').marginRight,
  },
  components: {
    PersonIcon: require('../social-feed/icons').default,
    CpBaseSvgIcon: require('../base-svg-icon').default,
    CpButtonLink: require('../button-link').default,
    CpImage: require('../image').default,
    CpSocialFeedOpinionPost: require('../social-feed/posts/opinion-post').default,
    CpButton: require('../button').default,
    CpGrid: require('../grid').default,
    CpGridItem: require('../grid-item').default,
    CpWysiwygInput: require('../inputs/wysiwyg').default,
    CpToasted: require('../toasted').default,
    getEmbedUrl: require('../mixins/utils.js').default,
    socialMediaName: require('../mixins/utils.js').default,
    OpenGraphPreview: require('../components/OpenGraphPreview').default,
    CpShowImageInCard: require('../components/ShowImageInCard').default,
    CpTextEditor: require('../components/TextEditor').default,
    CpTruncateText: require('../components/TruncateText').default,
    CpDisplaySocialMedia: require('../components/DisplaySocialMedia').default,
  },
  props: {
    data: { type: Object, default: () => {} },
    type: String,
    explore: Boolean,
    forShare: Boolean, //Is shared in explore tab
    reload: {
      type: Function,
      default: () => {
        console.log('Reload');
      },
    },
    modalShare: Boolean,
    enableTruncate: {type: Boolean, default: true},
  },
  data: function () {
    return {
      showMore: true,
      opinion: this.data?.opinion,
      isEditing: false,
      loadingEdit: false,
      toasted: [],
      hash: '',
    };
  },
  created() {
    const url = new URL(window.location.href);
    this.hash = url.hash;
  },
  computed: {
    authUser() {
      return this.$root.authUser ? this.$root.authUser : { id: null, is_admin: false };
    },
    isEndorse() {
      return this.data.type_opinion == 'Endorse';
    },
    isProtest() {
      return this.data.type_opinion == 'Protest';
    },
    invalidOpinion() {
      return this.opinion == null || this.opinion.trim() === '';
    },
    showLastActivity() {
      return this.data?.last_activity && this.data.last_activity.id !== this.data?.owner?.id;
    },
    videoEmbedUrl() {
      return this.getEmbedUrl(this.data.video);
    },
  },
  methods: {
    setIsEditing(value) {
      this.isEditing = value ? value : !this.isEditing;
    },
    profile(slug) {
      return '/profile/' + slug;
    },
    goToGroup(id) {
      return '/groups/' + id;
    },
    handleShowMoreButtonClicked() {
      this.showMore = !this.showMore;
    },
    showButtonMore() {
      return (
        ((this.$root.isMobile && !this.$root.isTablet && this.opinion.length > 300) ||
          (this.$root.isMobile && this.$root.isTablet && this.opinion.length > 500) ||
          (!this.$root.isMobile && this.opinion.length > 600)) &&
        !this.isEditing
      );
    },
    createAlert({ message = '', theme = 'info', duration = 2000 }) {
      this.toasted.push({ key: `alert-${new Date().toString()}`, message, theme, duration });
    },
    async opinionEdit(e, { opinion, gif, image, video }) {
      e.preventDefault();
      opinion = opinion.replace(/&nbsp;/g, '');
      if (image || video || gif || opinion.trim() !== '') {
        this.loadingEdit = true;

        if (this.type === 'opinion') {
          await editOpinion(this.data.id, { opinion, gif, image, video, type: this.type })
            .then(response => {
              this.setIsEditing(false);
              this.opinion = response.opinion.opinion;
              this.data.opinion = response.opinion.opinion;
              this.data.gif = response.opinion.gif;
              this.data.image = response.opinion.image;
              this.data.video = response.opinion.video;
            })
            .catch(error => {
              console.error(error);
            })
            .finally(() => {
              this.loadingEdit = false;
            });
        } else if (this.type === 'group-opinions') {
          await editGroupOpinion(this.data.id, { opinion, gif, image, video })
            .then(response => {
              this.setIsEditing(false);
              this.opinion = response.opinion.opinion;
              this.data.opinion = response.opinion.opinion;
              this.data.gif = response.opinion.gif;
              this.data.image = response.opinion.image;
              this.data.video = response.opinion.video;
              this.createAlert({
                message: 'The post has been successfully updated',
              });
            })
            .catch(error => {
              this.createAlert({ message: error.message, theme: 'danger' });
              console.error(error);
            })
            .finally(() => {
              this.loadingEdit = false;
            });
        }
      } else {
        this.createAlert({ message: 'Please enter a valid text!', theme: 'danger' });
      }
    },
    handleEditOpinion() {
      if (this.isEditing) {
        this.setIsEditing(false);
      } else {
        this.setIsEditing(true);
      }
    },
    extractDataUrl() {
      const dataUrlRegex = /<a[^>]*data-url=["']([^"']+)["'][^>]*>/;
      const match = this.data.opinion.match(dataUrlRegex);
      let dataUrl = '';
      if (match) {
        dataUrl = match[1];
      }
      return dataUrl;
    },
  },
};
</script>

<template>
  <div class="social-feed-post-wrapper">
    <div class="alerts">
      <cp-toasted v-for="toast in toasted" :key="toast.key" :message="toast.message" :theme="toast.theme" :duration="toast.duration" />
    </div>

    <!-- Last activity -->
    <!-- TO DO: uncomment this when we implement the new feed logic -->
    <!-- <div v-if="explore && showLastActivity && !forShare">
      <cp-grid spread stretch-content justify="spaceBetween">
        <cp-grid-item span="content" align="center">
          <a :href="profile(data.last_activity.slug)">
            <img :src="data.last_activity.image" class="image-user-activity" />
          </a>
          <span class="center-user">
            <a class="content-2 profile-link" :href="profile(data.last_activity.slug)">
              <span v-if="data.last_activity.first_name">{{ data.last_activity.first_name }}</span>
              <span v-if="data.last_activity.last_name">{{ data.last_activity.last_name }}</span>
            </a>
            <span class="content-1">{{ data.last_activity.action }}</span>
          </span>
        </cp-grid-item>
        <cp-grid-item span="content" align="center">
          <cp-button-link thin light-gray style="float: right" :href="profile(data.last_activity.slug)">
            <span>View Profile</span>
          </cp-button-link>
        </cp-grid-item>
      </cp-grid>

      <hr class="search-results__tick_action" style="margin-top: 10px; width: 100px !important" />
    </div> -->

    <div v-if="type == 'groups' && explore && forShare" class="box-group">
      <a :href="profile(data.owner.slug)">
        <cp-image
          :src="data.owner.profile_image"
          circular
          :width="$root.isMobile ? '25' : '40'"
          :height="$root.isMobile ? '25' : '40'"
          style="position: initial"
        ></cp-image>
      </a>
      <div style="display: inline; margin-left: 10px">
        <a :href="profile(data.owner.slug)">
          <span class="heading-4">{{ data.owner.name }}</span>
        </a>
        <i class="fas fa-caret-right fa-lg caret"></i>
        <a :href="data.group.permalink">
          <span class="heading-4">{{ data.group.title }}</span>
        </a>
      </div>
    </div>

    <div v-else-if="type == 'group-opinions' && explore" class="box-group" v-margin-bottom="0.5">
      <a :href="profile(data.owner.slug)">
        <cp-image
          :src="data.owner.profile_image"
          circular
          :width="$root.isMobile ? '25' : '35'"
          :height="$root.isMobile ? '25' : '35'"
          style="position: initial"
        ></cp-image>
      </a>
      <span style="margin-left: 10px">
        <a :href="profile(data.owner.slug)">
          <span class="buttons neutral6-color">{{ data.owner.name }}</span>
        </a>
        <span class="body neutral4-color"> {{ ' ' }} posted on {{ ' ' }} </span>
        <a :href="goToGroup(data.group.id)">
          <span class="buttons primary">{{ data.group.title }}</span>
        </a>
      </span>
    </div>

    <a v-else :href="profile(data.owner.slug)" class="center" v-margin-bottom="0.5">
      <cp-image
        :src="data.owner.profile_image"
        circular
        :width="$root.isMobile ? '38' : '50'"
        :height="$root.isMobile ? '38' : '50'"
        style="position: initial"
      ></cp-image>
      <span style="margin-left: 10px" class="heading-4">{{ data.owner.name }}</span>
    </a>

    <span
      v-if="isEndorse || isProtest"
      class="btn-type"
      v-bind:class="{ endorse: isEndorse, protest: isProtest }"
      style="display: flex; align-items: center; justify-content: flex-start"
      >{{ data.type_opinion }}</span
    >

    <!-- Description -->
    <div v-if="forShare && !explore" class="social-feed-post-profile-wrapper" style="display: block">
      <CpTruncateText :content="opinion" :lineClamp="8" :enableTruncate="enableTruncate" />
    </div>
    <!-- Editing description -->
    <div v-else class="social-feed-post-profile-wrapper" style="display: block">
      <CpTextEditor
        v-if="isEditing"
        :text="opinion"
        placeholder="Write a comment..."
        @sendMessage="opinionEdit"
        :withBackground="false"
        :primaryBtnType="false"
        submitButtonTitle="Save"
        :loadingSend="loadingEdit"
      />
      <CpTruncateText v-else :content="opinion" :lineClamp="8" :enableTruncate="enableTruncate" />
    </div>

    <div v-if="forShare && !modalShare" class="social-feed-post-profile-wrapper">
      <CpShowImageInCard v-if="data.image" :image="data.image" :link="data.permalink" altMessage="Post image" v-margin-top="0.5" />
      <div v-if="data.video" class="video-embed-container">
        <div v-if="videoEmbedUrl !== null" class="iframe-container">
          <CpDisplaySocialMedia :video="data.video" />
          <div class="watch-button">
            <CpButtonLink v-if="!forShare && hash !== '#post'" noborder lg :href="data.permalink" v-margin-right="0.5" class="btnClass">View Post</CpButtonLink>
            <CpButtonLink noborder lg openExternally :href="extractDataUrl()" v-margin-top="1">Watch on {{ socialMediaName(data.video) }}</CpButtonLink>
          </div>
        </div>
        <div v-else class="video-container">
          <video controls preload="metadata" style="max-width: 100%; height: auto">
            <source :src="`${data.video}#t=0.2`" type="video/mp4" />
          </video>
        </div>
      </div>
      <img v-if="data.gif" class="gif" :src="data.gif" />
    </div>

    <div v-else class="social-feed-post-profile-wrapper">
      <CpShowImageInCard v-if="data.image" :image="data.image" :link="data.permalink" altMessage="Post image" v-margin-top="0.5" />
      <div v-if="data.video" class="video-embed-container">
        <div v-if="videoEmbedUrl !== null" class="iframe-container">
          <CpDisplaySocialMedia :video="data.video" />
          <div class="watch-button">
            <CpButtonLink v-if="!forShare && hash !== '#post'" noborder lg :href="data.permalink" v-margin-right="0.5" class="btnClass">View Post</CpButtonLink>
            <CpButtonLink noborder lg openExternally :href="extractDataUrl()" v-margin-top="1" class="btnClass">Watch on {{ socialMediaName(data.video) }}</CpButtonLink>
          </div>
        </div>
        <div v-else class="video-container">
          <video controls preload="metadata" style="max-width: 100%; height: auto">
            <source :src="`${data.video}#t=0.2`" type="video/mp4" />
          </video>
        </div>
      </div>
      <img v-if="data.gif" class="gif" :src="data.gif" />
    </div>

    <span v-if="!forShare && hash !== '#post' && videoEmbedUrl === null">
      <CpButtonLink noborder lg :href="data.permalink" class="btnClass">View Post</CpButtonLink>
    </span>

    <OpenGraphPreview v-if="data.opinion" :content="data.opinion" />

    <!-- Details -->
    <cp-social-feed-opinion-post
      v-if="!forShare"
      :opinion="data"
      :explore="explore"
      :type="type"
      :createAlert="createAlert"
      :reload="reload"
      :edit="handleEditOpinion"
      :loadingEdit="loadingEdit"
      :isEditing="isEditing"
    />
  </div>
</template>

<style scoped>
.caret {
  color: #ff4814;
  margin: 7px;
}
.box-group {
  display: flex;
  align-items: center;
}
.center-user {
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-user-activity {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  margin-right: 10px;
}
.center {
  display: flex;
  align-items: center;
}
.pointer {
  cursor: pointer;
}
.box-comment {
  display: block;
  resize: none;
  overflow: auto;
  border-style: hidden;
  width: 100%;
  outline: none;
  margin-top: 10px;
}
.ml-5 {
  margin-left: 5px;
}
.social-feed-post-profile-wrapper {
  display: flex;
  flex-direction: row;
}
.social-feed-post-profile-wrapper .details-wrapper {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
}

.social-feed-post-profile-wrapper .profile-name {
  font-size: 1.3em;
  font-weight: 600;
  padding-bottom: 5px;
  padding-right: 5px;
  margin: 1px;
}

.social-feed-post-profile-wrapper .post-time {
  font-size: 0.9em;
  color: #666;
  font-weight: 400;
  margin-right: 20px;
  text-decoration: none;
}

.social-feed-post-profile-wrapper > p {
  width: 100%;
}

.social-feed-post-profile-wrapper > p > img {
  width: 100%;
  object-fit: cover;
  max-height: 450px;
}

.social-feed-post-profile-wrapper > p > img.gif {
  max-height: 100%;
}

img.social-feed-post-img {
  max-width: 100%;
  max-height: 100%;
  min-width: 100%;
}
span.social-feed-default-img {
  display: flex;
  align-items: center;
  justify-content: center;
}
a.social-feed-post-link {
  display: block;
  padding-top: 10px;
  font-size: 1.1em;
}

div.social-feed-post-wrapper {
  width: 100%;
  padding: 1em;
  border-bottom: 2px solid var(--neutral3);
  border-radius: 3px;
  margin-bottom: 1.7em;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
}
div.social-feed-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.social-feed-post-wrapper > * {
  width: 100%;
}
.mini-recipient {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.mini-recipient {
  margin-top: -5px;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  font-weight: 400;
  align-items: center;
  display: inline-flex;
  color: #787878;
  font-size: 14px;
  line-height: 1.3;
  text-align: left;
}

a.heading-4 {
  text-decoration: none;
}

div.social-feed-box-wrapper.mobile img.social-feed-post-img {
  min-height: 45vh;
  object-fit: cover;
}
.social-feed-default-img {
  background: #ffe3da;
  color: var(--highlight);
}
div.social-feed-box-wrapper.mobile div.social-feed-post-wrapper {
  padding: 0.7em;
}
div.social-feed-post-img-placeholder {
  min-height: 400px;
  background: rgb(233, 94, 54);
  background: linear-gradient(180deg, rgba(233, 94, 54, 1) 65%, rgba(254, 130, 94, 1) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
header.social-feed-title-header {
  text-align: center;
  margin: 30px 0px;
}
div.social-feed-post-description {
  padding-top: 10px;
}
video.candidate-video-player {
  width: 100%;
  height: auto;
}
.profile-img.social-feed-default-img svg {
  margin-top: 10px;
}
.profile-img {
  width: 45px;
  height: 45px;
}

.social-feed-sidebar {
  position: fixed;
}
.search-results__tick_action {
  width: 50px !important;
  margin-right: auto;
}
.header-label {
  font-size: 16px;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  font-weight: 600;
  color: #121212;
}

.mobile-fixed-bottom-sidebar .social-feed-right-sidebar {
  padding: 15px;
  position: relative;
  max-width: 100% !important;
}

.small-desktop-right-sidebar .social-feed-right-sidebar {
  max-width: 12.2vh;
}

.small-desktop-right-sidebar .title-3 hr {
  display: none;
}

.mobile-fixed-bottom-sidebar {
  position: fixed;
  background: white;
  width: 100% !important;
  bottom: 0px;
  left: 0px;
  margin: 0px;
}
/** */
.btn-type {
  text-shadow: none;
  text-decoration: none !important;
  box-shadow: none;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  font-weight: 400;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  color: #fff;
  font-size: 16px;
  line-height: 1.6;
  padding: 0px 20px;
  text-align: center;
}
.endorse {
  background: #22bb69;
}
.protest {
  background: #f53c3c;
}
.opinion {
  font-size: 20px;
  line-height: 1.6;
  color: #000000;
  overflow-wrap: break-word !important;
  margin-bottom: 0px;
  margin-left: 5px;
}
p.opinion-share {
  max-width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.video-embed-container,
.watch-button {
  width: 100%;
}
.video-embed-container .video-container {
  display: flex;
  justify-content: center;
}
.iframe-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.alerts {
  position: absolute;
  top: 1em;
  left: 1em;
  right: 1em;
  z-index: 9999;
}
.btnClass {
  background-color: transparent;
}
</style>
